// extracted by css-extract-rspack-plugin
export default {"root":"root-Iw_DSa","item":"item-Bm2KzU"};